import { DecimalPipe } from '@angular/common';
import { Component, ComponentRef, inject, Injector, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { DialogService } from 'app/services/dialog.service';
import { LanguageService, LanguageModel } from 'app/services/language.service';
import { InterfacePermissions, UsersService, UserViewModel } from 'app/services/users.service';
import { UsersDialogComponent } from 'app/system/shared/components/users-dialog/users-dialog.component';
import { filter, Subject, takeUntil } from 'rxjs';
import { BaseProfileService } from './services/base-profile-service';
import { IProfileModel } from '../mobile-models/profile-models';

@Component({
    selector: 'app-mobile-system',
    templateUrl: './mobile-system.component.html',
    styleUrls: ['./mobile-system.component.css'],
    standalone: false
})
export class MobileSystemComponent implements OnInit, OnDestroy {

  public interfacePermissions = InterfacePermissions;
  private languageService = inject(LanguageService);
  private router = inject(Router);
  public baseProfileService = inject(BaseProfileService);
  public usersService = inject(UsersService);
  language: LanguageModel;
  public languages: LanguageModel[] = [];

  currentTitle: string = '';
  routeTitles: Record<string, string> = {
    // '/dashboard': 'Analytics',
    '/': 'Tracking',
    // '/history': 'History',
    // '/notifications': 'Notifications',
    '/geozones': 'Geozones',
    '/settings': 'Settings',
    '/reports': 'Reports'
  };

  model: boolean = true;
  isOpen: boolean = false;
  profile: IProfileModel;
  user: UserViewModel;
  private readonly destroy$ = new Subject<void>();

  constructor() {
    this.language = this.languageService.defaultLanguage;
    this.languageService.getLanguages().subscribe(langs => {
      this.languages = langs;
    });
    this.baseProfileService.getProfileJson().subscribe((profile) => {
      this.profile = profile;
    });
    this.user = this.usersService.getCurrentUser();
  }

  toggleMenu() {
    this.isOpen = !this.isOpen;
  }

  logout() {
    this.usersService.logout();
    this.isOpen = false;
  }


  ngOnInit(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => {
        this.updateTitle(event.urlAfterRedirects);
      });

    // Also initialize for first load
    this.updateTitle(this.router.url);

    const user = this.usersService.getCurrentUser();

    this.languageService.getLanguages().pipe(takeUntil(this.destroy$)).subscribe(langs => {
      this.language = langs.find(
        l => l.code === user.Language
      ) || this.languageService.defaultLanguage;
      this.languageService.changeLanguage(this.language.code);
    });

    if (user != null && this.router.url.length < 2) {
      if (user.HasFlag("START_ANALYTICS")) {
        this.router.navigate(["dashboard"]);
        return;
      }
      if (user.HasFlag("START_REPORTS")) {
        this.router.navigate(["reports"]);
        return;
      }
      if (user.HasFlag("START_DRIVERS")) {
        this.router.navigate(["drivers"]);
        return;
      }
      if (user.HasFlag("START_FUEL")) {
        this.router.navigate(["fuel"]);
        return;
      }
      if (user.HasFlag("START_SERVICE")) {
        this.router.navigate(["service"]);
        return;
      }
      if (user.HasFlag("START_DISPATCHER")) {
        this.router.navigate(["dispatcher"]);
        return;
      }
    }

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  updateTitle(url: string) {
    // If there are query params, remove them
    const cleanUrl = url.split('?')[0];
    this.currentTitle = this.routeTitles[cleanUrl] || '';

    const match = Object.keys(this.routeTitles)
      .sort((a, b) => b.length - a.length)
      .find(path => cleanUrl.startsWith(path));

    this.currentTitle = match ? this.routeTitles[match] : '';

  }

  closeMenu() {
    this.isOpen = false;
  }

  // @ViewChild("navUsersDialog", { read: ViewContainerRef, static: true }) container;
  // componentRef: ComponentRef<any>;
}
